import mergeWith from "lodash/mergeWith";
import isPlainObject from "lodash/isPlainObject";

const getMergeKey = item => {
  if (!isPlainObject(item)) {
    return null;
  }

  if (typeof item.stock_id !== "undefined" && item.stock_id !== null) {
    return `stock_id:${item.stock_id}`;
  }

  return null;
};

const mergeWithDefinedValues = (portfolioData, dataFromWebSocket) =>
  mergeWith({}, portfolioData, dataFromWebSocket, (objValue, srcValue) => {
    if (srcValue === null || typeof srcValue === "undefined") {
      return objValue;
    }

    if (Array.isArray(srcValue)) {
      if (!Array.isArray(objValue)) {
        return srcValue;
      }

      const objItemsByKey = new Map(
        objValue
          .map(item => [getMergeKey(item), item])
          .filter(([key]) => key !== null)
      );

      return srcValue.map((srcItem, index) => {
        const srcKey = getMergeKey(srcItem);
        const objItem =
          srcKey !== null && objItemsByKey.has(srcKey)
            ? objItemsByKey.get(srcKey)
            : objValue[index];

        if (srcItem === null || typeof srcItem === "undefined") {
          return objItem;
        }

        if (isPlainObject(srcItem) && isPlainObject(objItem)) {
          return mergeWithDefinedValues(objItem, srcItem);
        }

        return srcItem;
      });
    }

    return undefined;
  });

const mergePortfolioData = (portfolioData, dataFromWebSocket) =>
  mergeWithDefinedValues(portfolioData, dataFromWebSocket);

export default mergePortfolioData;
